import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routes = [
    // {path:"/CNNTCR-Epp",redirect:'/CNNTCR-Epp/home'},
    {
        path: '/',
        name: 'home',
        component: () => import('../components/Home.vue')
    },
    {
        path: '/predict',
        name: 'predict',
        component: () => import('../components/Predict.vue')
    },
    {
        path: '/download',
        name: 'download',
        component: () => import('../components/Download.vue')
    },
    {
        path: '/citation',
        name: 'citation',
        component: () => import('../components/Citation.vue')
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('../components/Contact.vue')
    },
    {
        path: '/back',
        name: 'back',
        component: () => import('../components/PredictBack.vue')
    },
    {
        // 当匹配不到路由时，指定其转向目标地址
        path: '*', redirect: '/'
    }
]
const router = new Router({
    routes,
    mode: 'hash'
})
export default router